import React, { useState } from "react";
import "./CheckCardAvailability.css";
import { FaStar, FaRegStarHalfStroke } from "react-icons/fa6";
import { IoIosStarOutline } from "react-icons/io";
import Button from "react-bootstrap/Button";
import { ColorRing } from "react-loader-spinner";
import axios from "axios";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { AnimatePresence } from "framer-motion";
import { CheckCircle } from "lucide-react";

const CheckCardAvailability = ({ data }) => {
  const [loader2, setLoader2] = useState(false);
  const [show, setShow] = useState(false);
  const [indexs, setIndex] = useState("");
  const cardData = data.eligiblity.data;

  const StarRating = ({ rating }) => {
    const maxStars = 5;
    const stars = [];

    for (let i = 1; i <= maxStars; i++) {
      if (i <= rating) {
        stars.push(
          <FaStar
            key={i}
            className="card-rating-star"
            fill="#25866a"
            stroke="#25866a"
          />
        );
      } else if (i - 0.5 === rating) {
        stars.push(
          <FaRegStarHalfStroke
            key={i}
            className="card-rating-star"
            fill="#25866a"
            stroke="#25866a"
          />
        );
      } else {
        stars.push(
          <IoIosStarOutline
            key={i}
            className="card-rating-star"
            fill="#25866a"
            stroke="#25866a"
          />
        );
      }
    }

    return <div className="flex space-x-1">{stars}</div>;
  };

  const handleSubmit = async (name, irr, index) => {
    setLoader2(true);
    setIndex(index);
    const formId = localStorage.getItem("formId");

    try {
      const formData = new FormData();
      formData.append("card_name", name);
      formData.append("iRate", irr);
      formData.append("emi", data.monthlyEmi || 0);
      formData.append("monthlyIncome", data.annualIncome);
      formData.append("formId", formId);
      formData.append("amount", "0");
      formData.append("tenure", "0");

      const response = await axios.post(
        `${process.env.REACT_APP_URL}/applyLoan`,
        formData
      );

      if (response.data.status) {
        setShow(true);
      }
    } catch (error) {
      console.error("Submission error:", error);
    } finally {
      setLoader2(false);
      setIndex("");
    }
  };

  // console.log("dfsdf", cardData?.excatCards);

  return (
    <>
      {cardData?.otherCards?.length > 0 ? (
        <div id="Loan-Check-Card-Availability">
          <div className="CheckCard-Top-contentCon">
            <p id="CheckCard-title">
              {data?.cardname === cardData?.excatCards?.card_name
                ? "You're Eligible for Your Selected Card! Here's Your Perfect Match"
                : "The Card You Picked Doesn't Match - But This One Is Tailored Just For You"}
            </p>

            <div className="card-top-con mt-4">
              <div className="row p-0 m-0">
                <div className="col-12 col-md-4 p-0 pe-3 m-0">
                  <img
                    src={cardData?.excatCards?.card_img}
                    alt="Credit Card"
                    className="card-img"
                  />
                </div>

                <div className="col-12 col-md-8 pt-3 px-0 m-0">
                  <div className="d-block d-md-none mb-3 mb-md-0">
                    <p className="card-rating-left">MinEmi Ratings</p>
                    <div className="card-star-left">
                      <StarRating rating={cardData?.excatCards?.rating / 2} />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 col-md-8">
                      {/* <div id="travel-con">
                        <img
                          src="../../../../images/card/plane.png"
                          alt="Travel"
                        />
                        <p>{cardData?.excatCards?.bestFor}</p>
                      </div> */}

                      <h2 className="card-name">
                        {cardData?.excatCards?.card_name}
                      </h2>

                      <div className="card-text-con d-flex flex-row">
                        <p
                          className="text-title m-0 p-0 pe-2 d-flex flex-row justify-content-between"
                          style={{ width: "40%" }}
                        >
                          Annual Fee <span> :</span>{" "}
                        </p>
                        <p
                          className="text-content m-0 p-0"
                          style={{ width: "60%" }}
                        >
                          &#x20B9;{" "}
                          {(+cardData?.excatCards?.annual_fees).toLocaleString(
                            "en-IN",
                            {
                              maximumFractionDigits: 0, // optional: remove decimals
                            }
                          )}
                        </p>
                      </div>

                      <div className="card-text-con d-flex flex-row">
                        <p
                          className="text-title m-0 p-0 pe-2 d-flex flex-row justify-content-between"
                          style={{ width: "40%" }}
                        >
                          Interest Rate<span> :</span>{" "}
                        </p>
                        <p
                          className="text-content m-0 p-0"
                          style={{ width: "60%" }}
                        >
                          {cardData?.excatCards?.interest_rate}
                        </p>
                      </div>

                      <div className="card-text-con d-flex flex-row">
                        <p
                          className="text-title m-0 p-0 pe-2 d-flex flex-row justify-content-between"
                          style={{ width: "40%" }}
                        >
                          Intro Offers<span> :</span>{" "}
                        </p>
                        <p
                          className="text-content m-0 p-0"
                          style={{ width: "60%" }}
                        >
                          {cardData?.excatCards?.intro_offer}
                        </p>
                      </div>

                      <div className="card-text-con d-flex flex-row">
                        <p
                          className="text-title m-0 p-0 pe-2 d-flex flex-row justify-content-between"
                          style={{ width: "40%" }}
                        >
                          Recommended Credit Score<span> :</span>{" "}
                        </p>
                        <p
                          className="text-content m-0 p-0"
                          style={{ width: "60%" }}
                        >
                          {cardData?.excatCards?.min_cibil}
                        </p>
                      </div>
                    </div>

                    <div className="col-12 col-md-4 d-flex flex-column justify-content-between mt-4">
                      <div className=" d-none d-md-block">
                        <p className="card-rating-text">MinEmi Ratings</p>
                        <div className="card-star-con">
                          <StarRating
                            rating={cardData?.excatCards?.rating / 2}
                          />
                        </div>
                      </div>

                      <div className="apply-button-container">
                        {loader2 ? (
                          <Button className="check-card-apply-btn" disabled>
                            <ColorRing
                              visible={true}
                              height="30"
                              width="30"
                              colors={["#fff", "#fff", "#fff", "#fff", "#fff"]}
                            />
                          </Button>
                        ) : (
                          <Button
                            className="check-card-apply-btn"
                            onClick={() =>
                              handleSubmit(
                                cardData?.excatCards?.card_name,
                                cardData?.excatCards?.interest_rate,
                                ""
                              )
                            }
                          >
                            Apply Now
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="CheckCard-bottom-contentCon">
            <p id="CheckCard-bottom-title">
              Other Handpicked Cards Perfect For You
            </p>

            {cardData?.otherCards.map((card, index) => (
              <div className="card-bottom-con" key={index}>
                <div className="travel-con">
                  <p>{card?.bestFor}</p>
                </div>

                <div className="row  p-0 m-0">
                  <div className="col-12 col-md-4 p-0 m-0">
                    <img
                      src={card?.card_img}
                      alt="Credit Card"
                      className="card-image"
                    />
                  </div>

                  <div className="col-12 col-md-8 ps-0 ps-sm-4 pe-0 m-0">
                    <div className="row p-0 m-0">
                      <div className="col-12 col-md-8 m-0 p-0">
                        <div className="mobile-rating d-md-none my-3">
                          <p className="card-rating-left">MinEmi Ratings</p>
                          <div className="card-star-left">
                            <StarRating rating={card?.rating / 2} />
                          </div>
                        </div>

                        <h3 className="card-name">{card?.card_name}</h3>

                        <div className="card-text-con">
                          <p className="text-title m-0 p-0 pe-2">
                            Annual Fee <span> :</span>{" "}
                          </p>
                          <p className="text-content m-0 p-0 ">
                            &#x20B9;{" "}
                            {(+card?.annual_fees).toLocaleString("en-IN", {
                              maximumFractionDigits: 0, // optional: remove decimals
                            })}
                          </p>
                        </div>

                        <div className="card-text-con">
                          <p className="text-title m-0 p-0 pe-2">
                            Reward Rate <span> :</span>{" "}
                          </p>
                          <p className="text-content m-0 p-0">
                            {card?.reward_rate}
                          </p>
                        </div>

                        <div className="card-text-con">
                          <p className="text-title m-0 p-0 pe-2">
                            Intro Offers <span> :</span>{" "}
                          </p>
                          <p className="text-content m-0 p-0 ">
                            &#x20B9; {card?.intro_offer}
                          </p>
                        </div>

                        <div className="card-text-con">
                          <p className="text-title m-0 p-0 pe-2">
                            Recommend Credit Score <span> :</span>{" "}
                          </p>
                          <p className="text-content m-0 p-0">
                            {card?.min_cibil}
                          </p>
                        </div>
                      </div>

                      <div className="col-12 col-md-4 d-flex flex-column justify-content-between">
                        <div className="d-none d-md-block">
                          <p className="card-rating-text">MinEmi Ratings</p>
                          <div className="card-star-con">
                            <StarRating rating={card?.rating / 2} />
                          </div>
                        </div>

                        <div className="d-flex justify-content-end mt-4 mt-md-0">
                          {indexs === index ? (
                            <Button className="check-card-apply-btn" disabled>
                              <ColorRing
                                visible={true}
                                height="30"
                                width="30"
                                colors={[
                                  "#fff",
                                  "#fff",
                                  "#fff",
                                  "#fff",
                                  "#fff",
                                ]}
                              />
                            </Button>
                          ) : (
                            <Button
                              className="check-card-apply-btn"
                              onClick={() =>
                                handleSubmit(
                                  card?.card_name,
                                  card?.interest_rate,
                                  index
                                )
                              }
                            >
                              Apply Now
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className=" p-8" style={{ backgroundColor: "#f8f8f8" }}>
          <div className="mx-auto max-w-3xl">
            <div className="no-data-icon">
              <svg
                width={20}
                height={20}
                viewBox="0 0 24 24"
                fill="none"
                stroke="#341664"
                strokeWidth="2"
              >
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <path d="M14 2v6h6" />
                <path d="M12 18v-6" />
                <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
              </svg>
            </div>
            <h3 className="mt-4 text-center text-xl font-medium text-[#341664]">
              No Data Found
            </h3>
            <p className="mt-2 max-w-md text-center text-sm text-[#341664]/70">
              No data is found for the user
            </p>
          </div>
        </div>
      )}

      <Dialog open={show} onClose={() => setShow(false)}>
        <DialogContent className="success-dialog">
          <DialogTitle className="success-title">
            Application Submitted Successfully!
          </DialogTitle>

          <AnimatePresence>
            <div className="success-content">
              <CheckCircle className="success-icon" />
              <p className="success-message">
                Your responses have been recorded. Our team will review your
                feedback and get back to you soon!
              </p>
            </div>
          </AnimatePresence>

          <div className="dialog-actions">
            <Button
              className="close-button"
              onClick={() => setShow(false)}
              variant="outline"
            >
              Close
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CheckCardAvailability;
